import React, { FC, useContext } from 'react';
import { UiStateContext } from '../../context/UiStateContext';
import { CTACard } from '../CtaCard';
import { Divider } from '../Divider';
import { Grid } from '../Grid';
import { Panel } from '../Panel';
import { RequestAValuationBlade } from '../properties/RequestAValuationBlade';
import { HeroSearch, MultiSearchProps } from '../search/HeroSearch';
import { Section } from '../Section';

interface LocationActionSectionProps {
  // name: string;
  // url: string;
  // isArea?: boolean;
  defaultMultisearch?: MultiSearchProps;
}

export const LocationActionSection: FC<LocationActionSectionProps> = ({ defaultMultisearch }) => {
  const { setActiveBlade } = useContext(UiStateContext);
  return (
    <>
      <Section contained>
        <Divider />
      </Section>
      <Section contained background="gradient">
        <Grid desktopColumns="2">
          <Panel backgroundColor="white" shadow heading="Find a property">
            <HeroSearch defaultMultisearch={defaultMultisearch} />
          </Panel>
          <CTACard
            title="Looking for a property valuation?"
            lead="Get an accurate, no-obligation valuation from our local experts."
            backgroundColour="brand"
            shadow
            customButton={{
              label: 'Book your free valuation',
              onClick: () => setActiveBlade('propertyRequestAValuation'),
              eventClickBladeId: 'propertyRequestAValuation',
              arrowRight: true,
            }}
          />
          <RequestAValuationBlade />
        </Grid>
      </Section>
    </>
  );
};
